import {
	EmailIcon,
	FacebookRegularIcon,
	type Icon,
	InstagramIcon,
	LinkedInIcon,
	RedditIcon,
	TikTokIcon,
	TwitterIcon,
	YouTubeIcon,
} from '@change/ds-icons';

// Mimics Elections logic for social platforms, but only keeps a subset of common SocialPlatforms; omitting Tumblr, Substack, Bluesky
export const SOCIAL_PLATFORMS: SocialPlatform[] = [
	'facebook',
	'x',
	'instagram',
	'reddit',
	'youtube',
	'tiktok',
	'linkedin',
	'mailto',
];

type SocialIconVariant = 'facebook' | 'twitter' | 'instagram' | 'reddit' | 'default';
export type SocialPlatform = 'facebook' | 'x' | 'instagram' | 'reddit' | 'youtube' | 'tiktok' | 'linkedin' | 'mailto';
export type SocialLink = {
	platform: SocialPlatform;
	url: string;
	icon: React.FC<Icon>;
	variant: SocialIconVariant;
	domains: readonly string[];
};

type SocialPlatformConfig = Record<
	SocialPlatform,
	{ icon: React.FC<Icon>; variant: SocialIconVariant; domains: readonly string[] }
>;
export const SOCIAL_PLATFORM_CONFIG: SocialPlatformConfig = {
	facebook: { icon: FacebookRegularIcon, variant: 'facebook', domains: ['facebook.com', 'fb.com'] },
	x: { icon: TwitterIcon, variant: 'twitter', domains: ['x.com', 'twitter.com'] },
	instagram: { icon: InstagramIcon, variant: 'instagram', domains: ['instagram.com'] },
	reddit: { icon: RedditIcon, variant: 'reddit', domains: ['reddit.com'] },
	// eslint-disable-next-line @change-corgi/youtube-embeds-nocookies
	youtube: { icon: YouTubeIcon, variant: 'default', domains: ['youtube.com', 'youtu.be'] },
	tiktok: { icon: TikTokIcon, variant: 'default', domains: ['tiktok.com'] },
	linkedin: { icon: LinkedInIcon, variant: 'default', domains: ['linkedin.com'] },
	mailto: { icon: EmailIcon, variant: 'default', domains: ['mailto'] },
};
